export const publicPath = (path) => `${process.env.PUBLIC_URL}images/${path}`;